import { DS_getData, DS_setData } from '../DS/DS.Data'

export type Auth_State =
    | {
          status:
              | 'ready'
              | 'waiting-for-internet'
              | 'waiting-for-redirect'
              | 'dev-select'
              | 'pending-sync'
              | 'complete'
              | 'failure'
              | 'logged-out'
      }
    | { status: 'syncing'; takingAWhile?: boolean }
    | { status: 'pending-automatic-login'; email: string; password: string }

export const Auth_initialState: Auth_State = { status: 'ready' }

export function Auth_getState() {
    return DS_getData().auth
}

export function Auth_getStatus() {
    return Auth_getState().status
}

export function Auth_syncRequired() {
    return Auth_getStatus() === 'pending-sync'
}

export function Auth_setAsLoggedOut() {
    if (Auth_getStatus() === 'pending-automatic-login') return
    DS_setData('SessionExpired', () => ({ auth: { status: 'logged-out' } }))
}
